import React, { useState, useEffect, useRef } from 'react';
import T from 'prop-types';

import ExportSettingsPreview from './ExportSettingsPreview';
import PageModal from '../../../Modals/PageModal';
import Button from '../../../Buttons/Button';
import InputText from '../../../Inputs/InputText';
import { generateDateTimeSuffix, isDateTimeSuffix } from '../../../../utils/helpers';

const SaveExportModal = ({ open, report, onConfirm, onClose }) => {
  const inputTextRef = useRef();
  // Update name if it has date suffix pattern
  const [name, setName] = useState(
    isDateTimeSuffix(report.name) ? generateDateTimeSuffix() : report.name
  );

  const isUpsertDisabled = !name.trim();

  const handleUpsertExport = (e) => {
    e.preventDefault();
    if (isUpsertDisabled) return;

    onConfirm({ name });
    onClose();
  };

  // Effects
  useEffect(() => {
    // Select input text on open
    inputTextRef.current.select();
  }, []);

  return (
    <PageModal
      open={open}
      shouldCloseOnOverlayClick={false}
      hideCloseButton
      className="save-export-modal"
      header="Save Export"
      main={
        <form onSubmit={handleUpsertExport}>
          <div className="save-export-modal__body">
            <div className="save-export-modal__form-fields">
              <h3 className="h3">Export Name</h3>
              <InputText
                ref={inputTextRef}
                value={name}
                placeholder="Export Name"
                onChange={setName}
              />
            </div>
            <ExportSettingsPreview report={report} />
          </div>

          <div className="save-export-modal__footer">
            <Button size="lg" variant="secondary" onClick={onClose}>
              Edit Export
            </Button>
            <Button size="lg" disabled={isUpsertDisabled} type="submit">
              Save & Run Export
            </Button>
          </div>
        </form>
      }
      onClose={onClose}
    />
  );
};

SaveExportModal.propTypes = {
  open: T.bool.isRequired,
  report: T.object.isRequired,
  onConfirm: T.func,
  onClose: T.func.isRequired,
};

export default SaveExportModal;
